import { render, staticRenderFns } from "./ParticipantDialog.vue?vue&type=template&id=8c18d4f4&scoped=true"
import script from "./ParticipantDialog.vue?vue&type=script&lang=js"
export * from "./ParticipantDialog.vue?vue&type=script&lang=js"
import style0 from "./ParticipantDialog.vue?vue&type=style&index=0&id=8c18d4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c18d4f4",
  null
  
)

export default component.exports